module.exports = __webpack_public_path__ + "static/media/gal-3.628f87ae.jpeg";